// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__4zQwR","label":"LabeledBox_label__2vz6r"};